module.exports = __webpack_public_path__ + "img/ikco.bda5176.png";